module.exports = __webpack_public_path__ + "img/trofeu_p.7dbb215e.png";